import { useState, useEffect } from 'react';
import { Monitor, X } from 'lucide-react';

const MOBILE_BREAKPOINT = 768; // pixels

export default function ScreenSizeWarning() {
  const [showWarning, setShowWarning] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      if (window.innerWidth < MOBILE_BREAKPOINT && !dismissed) {
        setShowWarning(true);
      } else {
        setShowWarning(false);
      }
    };

    // Initial check
    checkScreenSize();

    // Listen for resize
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, [dismissed]);

  const handleDismiss = () => {
    setDismissed(true);
    setShowWarning(false);
  };

  if (!showWarning) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm p-4">
      <div className="relative max-w-sm w-full rounded-2xl border border-surface-600 bg-surface-800 p-6 shadow-xl">
        <button
          onClick={handleDismiss}
          className="absolute top-3 right-3 text-slate-500 hover:text-slate-300 transition-colors"
        >
          <X size={20} />
        </button>

        <div className="flex flex-col items-center text-center">
          <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-neon-cyan/10">
            <Monitor size={28} className="text-neon-cyan" />
          </div>

          <h2 className="mb-2 text-lg font-semibold text-slate-100">
            Larger Screen Recommended
          </h2>

          <p className="mb-5 text-sm text-slate-400">
            This admin dashboard is optimized for desktop use. For the best experience, please use a PC or tablet with a larger screen.
          </p>

          <button
            onClick={handleDismiss}
            className="w-full rounded-xl bg-neon-cyan/20 border border-neon-cyan/40 py-2.5 text-sm font-semibold text-neon-cyan hover:bg-neon-cyan/30 transition-all"
          >
            Continue Anyway
          </button>
        </div>
      </div>
    </div>
  );
}
